<template>
    <section id="reaction-speed">

        <div>
            <h1 class="title"> Reaction Speed </h1>
            <h2>Welcome to Reaction Speed, a game to test and compare your reaction times with other players.</h2>
            <p>
                <strong>How to play:</strong> Click anywhere in the blue box below to start.
                <br>
                As soon as the box turns from red to green, click once as fast as you can.
                <br>
                This will happen {{ totalRounds }} times and the average will be your score, the lower the better! 
            </p>
        </div>
        <!-- Game State: {{gameState}} -->

        <div @click="click" id="reaction-speed-game" class="box">

            <div id="game-message">{{ gameMessage }}</div>

            <div class="columns">
                <div class="column">
                    Average Speed = {{average}} ms
                </div>
                <div class="column">
                    Round {{round}} of {{totalRounds}}
                </div>
            </div>
            
        </div>

    </section>
</template>

<script>
export default {
    name: 'Reaction-Speed',
    data() {
        return {
            gameMessage: "",
            gameState: -1,
            totalRounds: 5,
            round: 0,
            scores: [],
            startTime: 0
        }
    },
    mounted() {
        this.gameState = 0;
    },
    computed: {
        average: function() {
            if (this.scores.length < 1) return 0;
            var sum = 0;
            for (const score of this.scores) sum+= score;
            return Math.round(sum/this.scores.length);
        }
    },
    watch: {
        gameState: function() {
            switch (this.gameState) {
                case 0:
                    this.gameMessage = "When this box turns green, click as soon as possible. Click to start!";
                    this.set_background("skyblue");
                    break;
                case 1:
                    this.gameMessage = "Get ready, click when the box turns green!";
                    this.set_background("lightcoral");
                    break;
                case 2:
                    this.gameMessage = "Get ready, click when the box turns green!";
                    this.set_background("mediumspringgreen");
                    break;
                case 3:
                    this.gameMessage = "Too soon! Click to try again.";
                    this.set_background("skyblue");
                    break;
                case 4:
                    this.gameMessage = "Reaction time: " + this.scores[(this.round-1)] + " ms. Click to continue.";
                    this.set_background("skyblue");
                    break;
                case 5:
                    this.gameMessage = "Your average reaction time was " + this.average + " ms. Click anywhere to try again.";
                    this.set_background("skyblue");
                    break;
                default:
                    this.gameMessage = "Error: Unknown gameState: "+this.gameState;
                    this.set_background("darkgray");
                    break;
            }
            return;
        }
    },
    methods: {
        click: function() {
            switch (this.gameState) {
                case 0: //First load, Game waiting to start
                    this.start_round();
                    break;
                case 1: //in round: wait phase
                    this.fail_round();
                    break;
                case 2: //in round: react phase
                    this.end_round();
                    break;
                case 3: //end of round: failed
                    this.round--;
                    this.start_round();
                    break;
                case 4: //end of round: succeeded
                    this.start_round();
                    break;
                case 5: //Game over
                    this.restart_game();
                    break;
                default: //Should never be accessed
                    console.log("Undefined gameState: " + this.gameState);
                    break;
            }
        return;
        },
        end_round: function() {
            const endTime = Date.now();
            this.scores.push(endTime - this.startTime);
            this.gameState = (this.round === this.totalRounds) ? 5 : 4;
        },
        fail_round: function() {
            this.gameState = 3;
        },
        restart_game: function() {
            this.scores.length = 0;
            this.round = 0;
            this.gameState = 0;
        },
        set_background: function(color) {
            var background = document.getElementById("reaction-speed-game");
            background.style.backgroundColor = color;
            return;
        },
        sleep: function(ms) {
            if ( ms === 0 ) {
                ms = Math.floor( Math.random() * 4000 );
            }
            const delay = ms;
            return new Promise(resolve => setTimeout(resolve, delay));
        },
        start_round: async function() {
            this.round++;
            this.gameState = 1;

            await this.sleep(2000);
            await this.sleep(0);

            if (this.gameState === 1) {
                this.startTime = Date.now();
                this.gameState = 2;
            }
            return;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
    text-align: center;
    margin: 1rem 0 1rem 0;
}

#game-message {
    margin: 3rem 0 3rem 0;
    height: 3rem;
}
#reaction-speed-game {
    margin: auto;
    width: 60%;
    padding: 2rem;
    font-weight: 600;
}
</style>
